<div class="volunteer-specialist-signups-dialog-part">

	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()" [rows]="specialistSignups()"></grid-content>

</div>